<template>
    <div class="processAdj-list">
        <div class="tools-bar">
            <div class="tools-search" @keyup.enter="handleSearch">
                <el-input maxlength="100" v-model.trim="searchKeyWord" placeholder="消息内容">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
        </div>
        <el-table :data="processAdjList" style="width: 100%;height:368px;overflow-y:auto" v-loading="loading" :border="true">
            <el-table-column label="动态消息内容">
                <template slot-scope="scope">
                    <p v-html="scope.row.content"></p>
                </template>
            </el-table-column>
            <el-table-column prop="processAdjType" label="类型">
                <template slot-scope="scope">
                    <template v-if="scope.row.processAdjType === 0" >其它</template>
                    <template v-if="scope.row.processAdjType === 1" >表单</template>
                    <template v-if="scope.row.processAdjType === 2" >文档</template>
                    <template v-if="scope.row.processAdjType === 3" >审批</template>
                    <template v-if="scope.row.processAdjType === 4" >项目管理</template>
                </template>
            </el-table-column>
            <el-table-column prop="created" label="操作时间"></el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row type="flex" justify="end">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :total="totalPageNum"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="queryFormData"
                >
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import Sidebox from '@/components/Sidebox';
    import { getProcessInstanceAdjList } from '@/data-model';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        mixins: [ mixinsNav ],
        components: {
            Sidebox
        },
        data () {
            return {
                processAdjList: [], // 列表数据
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1, // 总页数
                loading: false, // 列表的loading状态
                searchKeyWord: '' // 查询的关键字,
            };
        },
        props: {
            processInstanceId: { // 流程实例ID
                type: String
            }
        },
        created () {
        },
        methods: {
            async _initPage () {
                await this._getFormData();
            },
            async _getFormData () {
                this.loading = true;
                let formData = await getProcessInstanceAdjList({
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    content: this.searchKeyWord,
                    processInstanceId: this.processInstanceId
                });
                this.processAdjList = formData.data;
                this.currentPage = formData.currentPage;
                this.pageSize = formData.pageSize;
                this.totalPageNum = formData.totalPageNum;
                this.loading = false;
            },
            queryFormData (currentPage) {
                this.currentPage = currentPage;
                this._getFormData();
            },
            handleSearch () {
                this.currentPage = 1;
                this._getFormData();
            }
        }
    };
</script>

<style lang="less">
    .processAdj-list {
        height: 100%;
        width: 100%;
        .nameStyle{
            font-weight: bold; 
            color: rgb(249, 150, 59);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/ProcessAdjList/ProcessAdjList.vue